// https://github.com/remix-run/react-router/issues/8264

import { createHashHistory } from 'history'
import { unstable_HistoryRouter as HashRouter } from 'react-router-dom'
const history = createHashHistory()

export {
  HashRouter,
  history
}